module.exports = __webpack_public_path__ + "static/img/logo20250826.b7b28d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/logo20250826.png
// module id = lM+K
// module chunks = 23